import Css from "./style.module.scss";

import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Button from "nlib/ui/Button";
import Modal, { ModalFooter } from "nlib/ui/Modal";
import Money from "utils/Money";
import React, { useCallback, useMemo } from "react";
import Texts from "utils/Texts";

const PaymentAccountCurrencyMismatchWindow = ({
  docAmount,
  docCurrency,
  paymentAccountName,
  paymentAccountCurrency,
  onClose,
  ...restProps
}) => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const documentAmountText = useMemo(() => {
    if (typeof docAmount === "number") {
      return Money.toMoneyNumber(docAmount || 0).toLocaleString();
    }

    return docAmount || "0";
  }, [docAmount]);

  const modalText = useMemo(() => {
    return Texts.replaceVars(messages.documentCurrencyMismatch, {
      docAmount: documentAmountText,
      docCurrency,
      paymentAccountName: paymentAccountName || uiTexts.unknown,
      paymentAccountCurrency
    });
  }, [
    messages.documentCurrencyMismatch,
    documentAmountText,
    docCurrency,
    paymentAccountName,
    paymentAccountCurrency,
    uiTexts.unknown
  ]);

  const handleClose = useCallback(() => {
    onClose(false);
  }, [onClose]);

  const handleChangeCurrency = useCallback(() => {
    onClose(true);
  }, [onClose]);

  return (
    <Modal
      size="sm"
      title={uiTexts.warning}
      {...restProps}
      onClose={handleClose}>
      <div className={Css.text}>{modalText}</div>
      <ModalFooter>
        <Button outline large onClick={handleClose}>
          {uiTexts.keepAsIs}
        </Button>
        <Button primary large onClick={handleChangeCurrency}>
          {Texts.replaceVars(uiTexts.changeDocumentCurrency, { currency: paymentAccountCurrency })}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default React.memo(PaymentAccountCurrencyMismatchWindow);
